<!--
使用文档
	1：show方法执行getList
	2：endFlow  流程结束是使用	清空组件中的数据（选中状态等相关数据）
	3：EmitStationIdList  save方法向外传递EmitStationIdList事件 将选中的值得id数组】类型】名称数组向上传递
-->
<template>
	<div>
	<Windows :title="$t('cmd140',['高级筛选'])"
			 :size="'m'"
			 ref="filterAdv"
			 @Close='filterClose'
			 v-if="SonComponents.filter">
		<div :title="getLanguageStr('word1738','电站区域')">{{getLanguageStr('word1738','电站区域')}}</div>
		<div class="mt05x">
		<Select :name="'area0ID'"
				:list="filterAdvTemp.area0ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area0ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<Select v-if="filterAdvTemp.area0ID.active!=null && (filterAdvTemp.area1ID.data.length > 1)"
				:name="'area1ID'"
				:list="filterAdvTemp.area1ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area1ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<Select v-if="filterAdvTemp.area1ID.active!=null && (filterAdvTemp.area2ID.data.length > 1)"
				:name="'area2ID'"
				:list="filterAdvTemp.area2ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area2ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<Select v-if="filterAdvTemp.area2ID.active!=null && (filterAdvTemp.area3ID.data.length > 1)"
				:name="'area3ID'"
				:list="filterAdvTemp.area3ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area3ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<Select v-if="filterAdvTemp.area3ID.active!=null && (filterAdvTemp.area4ID.data.length > 1)"
				:name="'area4ID'"
				:list="filterAdvTemp.area4ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area4ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<Select v-if="filterAdvTemp.area4ID.active!=null && (filterAdvTemp.area5ID.data.length > 1)"
				:name="'area5ID'"
				:list="filterAdvTemp.area5ID.data"
				@Click="filterAdvSelect"
				:bindActive="filterAdvTemp.area5ID.active"
				:keyMap="{text:'name',value:'id'}"></Select>
		<!-- <InputText :addClass="{sizeS:true}" v-model="filter.keyword.active" :maxLength="500"></InputText> -->
		</div>
		<div class="mt2x" :title="$t('word728',['电站类型'])">{{$t('word728',['电站类型'])}}</div>
		<div class="mt05x lh15 mr1x_E curP_E">
		<Select :name="'type'"
				:list="plantTypeList"
				v-model="filterAdvTemp.type.active"
				:bindActive="filterAdvTemp.type.active"
				:keyMap="{text:'name',value:'value'}"></Select>
		<!-- <Checkbox v-for="(tag,key) in filterAdvTemp.stationTypes.active" :key="key" v-model="filterAdvTemp.stationTypes.active[key]" :text="getTypeText(key,filterAdv.stationTypes.tagKey)"></Checkbox> -->
		<!--<label><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="null">{{$t('cmd19',['全部'])}}</label>
			<label v-for="plant in getTypeText('','plantType',true)" :key="plant.id[0]"><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="plant.id[0]">{{plant.name}}</label>-->
		</div>
		<div class="mt2x"
			 :title="$t('word736',['并网类型'])">{{$t('word736',['并网类型'])}}</div>
		<div class="mt05x lh15 mr1x_E curP_E">
		<Select :name="'gridType'"
				:list="plantGridTypeList"
				v-model="filterAdvTemp.gridInterconnectionType.active"
				:bindActive="filterAdvTemp.gridInterconnectionType.active"
				:keyMap="{text:'name',value:'value'}"></Select>
		<!--<Checkbox v-for="(tag,key) in filterAdvTemp.stationTypes.active" :key="key" v-model="filterAdvTemp.stationTypes.active[key]" :text="getTypeText(key,filterAdv.stationTypes.tagKey)"></Checkbox> -->
		<!--<label><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="null">{{$t('cmd19',['全部'])}}</label>
			<label v-for="grid in getTypeText('','plantGridType',true)" :key="grid.id[0]"><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="grid.id[0]">{{grid.name}}</label>-->
		</div>
		<div class="mt2x"
			 :title="$t('word727',['装机容量'])+'(kWp)'">{{$t('word727',['装机容量'])+'(kWp)'}}</div>
		<div class="mt05x dpIB_E vaM_E">
		<InputText class="w40pct"
					 :placeholder="getLanguageStr('phrase624','最小装机容量,不填则无下限')"
					 :only="'absNumber'"
					 ref="filterAdvPowerLower"
					 v-model="filterAdvTemp.powerArea.active[0]"
					 name="powerAreaMin"
					 :isError="{error:capacityFalse}"></InputText>
		<span class="w1x taC">~</span>
		<InputText class="w40pct"
					 :placeholder="getLanguageStr('phrase625','最大装机容量,不填则无上限')"
					 :only="'absNumber'"
					 ref="filterAdvPowerHigher"
					 v-model="filterAdvTemp.powerArea.active[1]"
					 name="powerAreaMax"
					 :isError="{error:capacityFalse}"></InputText>
		<div v-if="capacityFalse"
			 class="cError"
			 style="display:block">{{getLanguageStr('phrase673','最小装机容量不可以大于最大装机容量')}}</div>
		</div>
		<div class="mt2x"
			 :title="getLanguageStr('word1711','投产状态')">{{getLanguageStr('word1711','投产状态')}}</div>
		<div class="mt05x lh15 mr1x_E curP_E">
		<Select :name="'runState'"
				:list="runStateSList"
				v-model="filterAdvTemp.runState.active"
				:bindActive="filterAdvTemp.runState.active"
				:keyMap="{text:'name',value:'value'}"></Select>
		<!--<label v-for="run in getTypeText('','runStateS',true)" :key="run.id[0]"><input type="radio" name="runState" v-model="filterAdvTemp.runState.active" :value="run.id[0]">{{run.name}}</label>-->
		</div>
		<div class="mt2x"
			 :title="$t('word1336',['成员'])">{{$t('word1336',['成员'])}}</div>
		<div class="mt05x">
		<related-person class="w90pct"
						title=""
						:maxNum='5'
						@Update="updatePersonList"
						ref="SearchPerson"
						:initPersonData="filterAdvTemp.members.list"
						></related-person>
		</div>
		<div class="mt2x"
			 :title="$t('word1546',['用户'])">{{$t('word1546',['用户'])}}</div>
		<div class="mt05x">
		<RelatedUser class="w90pct"
					 :type="'filter'"
					 :list="filterAdvTemp.user.list"
					 :maxAddNum='5'
					 @Update="(data)=>{filterAdvTemp.user.list=data}"
					 ref="TagManageUser"></RelatedUser>
		</div>
		<div class="mt2x"
			 :title="$t('word1650',['商家'])">{{$t('word1650',['商家'])}}</div>
		<div class="mt05x">
		<RelatedBusiness class="w90pct"
						 :type="'filter'"
						 :list="filterAdvTemp.business.list"
						 :maxAddNum='5'
						 @Update="(data)=>{filterAdvTemp.business.list=data}"
						 ref="TagManageBusiness"></RelatedBusiness>
		</div>
		<TagManageCore :type="1"
					 :maxAddNum='5'
					 :list="filterAdvTemp.tag.list"
					 @Update="(data,action)=>{filterAdvTemp.tag.list=data}"
					 class="mt2x posR w90pct"
					 ref="TagManageCore"></TagManageCore>
		<!-- (data,action)=>{$emit('Update',data,action);} -->
		<button slot="btmBtn"
				class="functionBtn"
				@click="filterConfirm"
				:title="$t('cmd12',['确定'])"
				type="button">{{$t('cmd12',['确定'])}}</button>
	</Windows>
	<div id='selectView'>
		<div :class="fromInset?'bdSub h30-max':'bgDesktop pl1x pt1x pr1x pb1x'">
		<loading v-show="loading"></loading>
		<div class="tableSys filter" :class='{"custcss":fromW}'>
			<div class='panel bgPanel w40pct'>
			<div class='wrap-stat'>
				<div v-if='title' class='fs14x'>{{title}}</div>
				<InputText class="dpIB m2b1" name="groupMemberName"
						 :addClass="{'bgContent':true}"
						 :placeholder="getLanguageStr('phrase870','输入电站名称')"
						 :clearBtn="true"
						 :searchBtn="true"
						 v-model="searchKey"
						 ref="searchBox"
						 :fn="searchList"
						 @AfterClear="afterclear"></InputText>
				 <button class="fSub pl1x pr1x hover-f-main"	:title="$t('cmd140',['高级筛选'])"	@click="openFilterAdv"
						type="button"
						v-if="filterFlag">
				<Icon name="filter" class="ico w1x h1x mr5" v-if="filterFlag"/>{{$t('cmd140',['高级筛选'])}}</button>
				<div class='tableSys'>
				<div class='taL'>
				</div>
				</div>
				<div class="filterArea bgContent pb1x dpN">
				<transition-group name=""
									class="tagList cb fL_E ml1x_E mt1x_E ofH_E"
									v-on:leave="el=>{transitionAction(el,'hide-x');}"
									:duration="500">
					<TagBox v-for="(tag,key) in tagMap"
							:key="key"
							class="show"
							:title="filterAdv[tag.key].name"
							:val="filterAdv[tag.key].tagKey?getTypeText(tag.val,filterAdv[tag.key].tagKey):tag.val"
							@Remove="getList( {[tag.key]:(filterAdv[tag.key].type=='checkbox'?{[tag.val]:false}:{active:filterAdv[tag.key].def})} ,'filterAdv','remove')"></TagBox>
					<button class="cField sizeS"
							:key="0"
							@click="getList('clear')"
							type="button">{{$t("cmd258",["清空筛选"])}}</button>
				</transition-group>
				</div>
				<div class="splitLine"></div>
				<!--全选部分文本-->
				<div :class="fromInset?'h19x-max content pl2x bdSub':'pt1x pb1x'" :fillheight="fromInset?'.content':'lastHeight,-space,-.sendinspectList'" scroll>
				<loading v-show="loadingDate"></loading>
				<div class='h2x-min'	v-show="listCopy.length">
					<div class='mt1x'
						 v-for="(item, index) in listCopy"
						 :key='item.id'>
					<Checkbox v-show='qtyType=="multiple"' :disabled='item.isdisable'
								v-model="item.isSelect"
								:index='index'
								:checkObj='item'
								@Click="selectData"
								:text="item.name"></Checkbox>
					<MyRadio v-show='qtyType=="single"'
								v-model="selectItems"
								:label='item.id'
								:checkObj='item'
								@change="selectData"
								:text="item.name"></MyRadio>
					</div>
				</div>
					<div class="no-data cSub taC pt2x"	v-show="!listCopy.length">
					<span>{{$t('word1380',['暂无数据'])}}</span>
						</div>
				</div>
			</div>
			<div class="tableSys pl2x pr2x pb2x pt2x sendinspectList bdSub-top tableBatch bgContent cSub tra-fast vaM_E" v-if="filterFlag">
				<div class='vaM_E'>
				<Checkbox v-show='qtyType=="multiple"'
							:status='checkStatus'
							v-model="isSelectAll"
							@Click="selectAllData"
							:text="$t('cmd91',['全选'])"
							class='mr2x'></Checkbox>
				<Pagination :pagination="pagination" :pageSize="[{text:20,value:20},{text:100,value:100},{text:300,value:300},{text:500,value:500}]":getList="getList"></Pagination>
				</div>
				<div	v-show='qtyType=="multiple"' class='taR w10x'><span>{{getLanguageStr('word56','已选')+'('}}<span class='cMain'>{{selectNum}}/</span>{{pagination.total}}) </span></div>
			</div>
			</div>

		</div>

		</div>
	</div>
	</div>
	<!-- :pageSize="[{text:500,value:500},{text:1000,value:1000},{text:1500,value:1500},{text:2000,value:2000}]" -->
</template>
<script>
import InputText from '@/components/common/ui/InputText';

import Window from '@/components/common/ui/WindowForNew';
import Checkbox from '@/components/common/ui/Checkbox';
import RadioGroup from '@/components/common/ui/RadioGroup';
import Windows from '@/components/common/ui/WindowForAlert.vue';
import {getLanguageStr} from '@/util/language';
import TagBox from '@/components/common/ui/TagBox.vue';
import * as lib from '@/util/lib';
import Pagination from '@/components/common/ui/Pagination';
import Loading from '@/components/common/ui/Loading';
// import {getOStruct, addORole, getRoleDetail, updateORole} from '@/api/manage/roleFunc.js';
import MyRadio from '@/components/common/ui/Radio';
// import {mapGetters, mapActions} from 'vuex';
import Select from '@/components/common/ui/Select';
import {apiGetList, apiDeletePlant, apiGetPlantDetail,	StationBasicInfo, StationCost, MonthHistory, OperationDelete, MeterUnconfigured, apiSetFollow}	from '@/api/maintain/plant/list.js';
import AddPerson from '@/view/maintain/light/plant/part/AddPerson.vue'; // 添加关联人
import RelevancePart from '@/view/maintain/part/RelevancePart.vue'; // 授权
import RelatedUser from '@/view/maintain/light/plant/relevance/RelevanceUser.vue';
import RelatedBusiness from '@/view/maintain/light/plant/relevance/RelevanceBusiness.vue';
import RelatedPerson from '@/view/maintain/light/plant/part/RelatedPerson.vue';
import TagManageCore from '@/components/common/tagManage/Core.vue';
import TagManageForObject from '@/components/common/tagManage/ForObject.vue';
import {searchAreaList, searchAreaListByLevel} from '@/api/base.js';
// import clickoutside from '@/plugins/clickOutSide/index.js';
import Help from '@/components/common/Help.vue';
let app;
export default {
	name: 'selectStationCommon',
	components: {
		InputText,
		Loading,
		Window,
		Checkbox,
		RadioGroup,
		MyRadio,
		Select,
		AddPerson,
		RelevancePart,
		RelatedBusiness,
		RelatedUser,
		RelatedPerson,
		TagManageCore,
		TagManageForObject,
		TagBox,
		Windows,
		Help,
		Pagination
	},

	props: {
		map: {
			type: Object,
			default: () => ({})
		},
		title: {
			type: String,
			default: ''
		},
		filterFlag: {
			type: Boolean, // 含高级筛选加分页
			default: true
		},
		fromInset: {
			type: Boolean, // 是否是内嵌页面
			default: false
		},
		fromW: {
			type: Boolean, // 是否是内嵌页面
			default: false
		},
		powerTypeList: {// 传入指定的电站能源类型
			type: Array,
			default: undefined
		}
	},
	data () {
		return {
			stage,
			selectItems: '',
			selectNum: 0,
			checkStatus: 0,
			total: 0,
			listCopy: [],
			loading: false,
			activeInspectType: '电站',
			isSelectAll: false,
			requestData: {}, // api请求发送数据
			capacityFalse: false,
			canCheckNum: 0,
			showClickNum: 0,
			loadingDate: false,
			SonComponents: {
				viewDetailOpen: false,
				addPerson: false,
				newPlant: false,
				filter: false,
				tagManage: false
			},
			stationIdList: [],
			stationNameList: [],
			filterQuick: {
				// xxxx:{
				// request:true,是否合并到请求数据中去
				//	name:"",国际化文本，没有则不会创建筛选tag
				//	def:,默认值
				//	active:,生效值
				//	tagKey:"",值翻译对照字段名(不设置则直接输出值)
				//	parent:"",最终输出请求数据中所属上一级的字段名
				//	type:""交互类型，并影响解析、重组数据
				// }

				name: {def: '', active: ''}, // 搜索
				// statuses:{//状态
				//	def:{1:false,2:false,3:false,99:false},
				//	active:{
				//		1:this.$route.query.quickType=="1"?true:false,
				//		2:this.$route.query.quickType=="2"?true:false,
				//		3:this.$route.query.quickType=="3"?true:false,
				//		99:this.$route.query.quickType=="99"?true:false
				//	},
				// }
				networkStatus: {
					def: null,
					active: this.$route.query.networkStatus || null,
					keyBefore: ''
				},
				warningStatus: {
					def: null,
					active: this.$route.query.warningStatus || null,
					keyBefore: ''
				},
				following: {
					def: null,
					active: this.$route.query.following || null,
					keyBefore: ''
				}
				// followFlag:{def:false,active:false}//特别关注
			},
			plantTypeList: (function () {
				let y = lib.getTypeText('', 'plantType', true);
				let obj = [{id: ['ALL', '0'], name: getLanguageStr('cmd19', '全部'),	value: null}];
				return obj.concat(y);
			}()),
			statusCount: (function () {
				let obj = {};
				$.each(lib.getTypeText('', 'communicationStateS_plant_l', true), function () {
					obj[this.id[0]] = 0;
				});
				obj.TOTAL = 0;
				return obj;
			}()),
			plantGridTypeList: (function () {
				let y = lib.getTypeText('', 'plantGridType', true);
				let obj = [{id: ['ALL', '0'], name: getLanguageStr('cmd19', '全部'),	value: null}];
				return obj.concat(y);
			}()),
			runStateSList: (function () {
				let y = lib.getTypeText('', 'runStateS', true);
				let obj = [{id: ['ALL', '-1'], name:	getLanguageStr('cmd19', '全部'), value: null}];
				return obj.concat(y);
			}()),
			pagination: {
				request: {
					page: 1,
					size: 100000
				},
				total: 0
			},
			list: [],
			Allnum: 0,
			filterAdv: {
				// type:{
				//	request:true,
				//	name:getLanguageStr('word728','电站类型'),
				//	def:{1:false,2:false,3:false,4:false},
				//	active:{1:false,2:false,3:false,4:false},
				//	tagKey:"plantType",
				//	type:"checkbox"
				// },
				type: {
					request: true,
					name: getLanguageStr('word728', '电站类型'),
					def: null,
					active: null,
					tagKey: 'plantType',
					type: 'radio',
					keyBefore: ''
				},
				gridInterconnectionType: {
					request: true,
					name: getLanguageStr('word736', '并网类型'),
					def: null,
					active: null,
					tagKey: 'plantGridType',
					type: 'radio',
					keyBefore: ''
				},
				relatedPersonIds: {
					request: true,
					name: getLanguageStr('manage76', '成员'),
					def: '',
					displayValDef: '',
					fullListDef: '',
					active: '',
					// tagKey:this.getPersonNameById,
					fullList: '',
					keyBefore: ''
				},
				stationAreaMin: {
					request: true,
					// name:getLanguageStr('crm45','估算电站面积最小值'),
					def: '',
					active: ''
				},
				stationAreaMax: {
					request: true,
					// name:getLanguageStr('plant319','估算电站面积最大值'),
					def: '',
					active: ''
				},
				// stationArea:['-1~-1','-1~-1',getLanguageStr('crm8','估算电站面积'),"tag","plantArea","searchLeadDto"],
				estimateInstalledCapacityMin: {
					request: true,
					name: getLanguageStr('assess1', '估算装机容量最小值'),
					def: '',
					active: ''
				},
				estimateInstalledCapacityMax: {
					request: true,
					name: getLanguageStr('assess2', '估算装机容量最大值'),
					def: '',
					active: ''
				},
				runState: {
					request: true,
					name: getLanguageStr('word1711', '投产状态'),
					def: null,
					active: '',
					tagKey: 'runStateS',
					type: 'radio',
					keyBefore: ''
				},
				// estimateInstalledCapacity:['-1~-1','-1~-1',getLanguageStr('crm9','估算装机容量'),"tag","","searchLeadDto"],
				powerArea: {
					name: getLanguageStr('word727', '装机容量'),
					def: ['', ''],
					active: ['', '']
				},
				powerLower: {
					request: true,
					name: getLanguageStr('plant27', '最小装机容量，不填则无下限'),
					def: '',
					active: ''
				},
				powerHigher: {
					request: true,
					name: getLanguageStr('plant28', '最大装机容量，不填则无上限'),
					def: '',
					active: ''
				},
				addressOut: {
					name: getLanguageStr('word758', '电站位置'),
					def: ['', '', '', ''],
					active: ['', '', '', '']
				},
				tag: {
					name: getLanguageStr('word1471', '标签'),
					list: []
				},
				members: {
					name: getLanguageStr('word1336', '成员'),
					list: []
				},
				user: {
					name: getLanguageStr('word1546', '用户'),
					list: []
				},
				business: {
					name: getLanguageStr('word1650', '商家'),
					list: []
				},
				area0ID: {// getLanguageStr('word675','国家')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word675', '国家')}],
					keyBefore: ''
				},
				area1ID: {// getLanguageStr('word676','省')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word676', '省')}],
					keyBefore: ''
				},
				area2ID: {// getLanguageStr('word677','市')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word677', '市')}],
					keyBefore: ''
				},
				area3ID: {// getLanguageStr('word889','区')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word889', '区')}],
					keyBefore: ''
				},
				area4ID: {// getLanguageStr('word889','区')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word889', '区')}],
					keyBefore: ''
				},
				area5ID: {// getLanguageStr('word889','区')
					request: true,
					def: null,
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word889', '区')}],
					keyBefore: ''
				}
			},
			filterAdvTemp: {
				// type:{
				//	active:{1:false,2:false,3:false,4:false}
				// },
				type: {
					active: null
				},
				gridInterconnectionType: {
					active: null
				},
				relatedPersonIds: {
					active: ''
					// fullList:{}
				},
				stationAreaMin: {
					active: ''
				},
				stationAreaMax: {
					active: ''
				},
				estimateInstalledCapacityMin: {
					active: ''
				},
				estimateInstalledCapacityMax: {
					active: ''
				},
				powerArea: {
					active: ['', '']
				},
				powerLower: {
					active: ''
				},
				powerHigher: {
					active: ''
				},
				runState: {
					active: ''
				},
				addressOut: {
					active: ['', '', '', '']
				},
				tag: {
					name: getLanguageStr('word1471', '标签'),
					list: []
				},
				members: {
					name: getLanguageStr('word1336', '成员'),
					list: []
				},
				user: {
					name: getLanguageStr('word1546', '用户'),
					list: []
				},
				business: {
					name: getLanguageStr('word1650', '商家'),
					list: this.$route.params.business || []
				},
				area0ID: {// getLanguageStr('word675','国家')
					active: null,
					data: []
				},
				area1ID: {// getLanguageStr('word676','省')
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word676', '省')}]
				},
				area2ID: {// getLanguageStr('word677','市')
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word677', '市')}]
				},
				area3ID: {// getLanguageStr('word889','区')
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('word889', '区')}]
				},
				area4ID: {// getLanguageStr('word889','区')
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('cmd19', '全部')}]
				},
				area5ID: {// getLanguageStr('word889','区')
					active: null,
					data: [{name: getLanguageStr('cmd19', '全部'),	id: null, def: getLanguageStr('cmd19', '全部')}]
				}
			},
			tagMap: {// 用于记录生效的筛选条件
				// xxxx:{val:"",key:""}
			},
			searchKey: '',
			inspectType: [{text:	'电站', value: '电站'}],
			allStatus: 0, // 全选状态
			timeuse: '0s',
			selectItem: [],
			qtyType: 'multiple'
		};
	},
	watch: {
		Allnum: function (v) {
			if (v === this.canCheckNum && v !== 0) {
				//		this.allStatus = 2
				this.timeSpend(v);
			} else if (v !== 0 && v < this.canCheckNum) {
				//	 this.allStatus = 1
				this.timeSpend(v);
			} else {
				//	 this.allStatus = 0
				this.timeSpend(v);
			}
		},
		selectNum (v) {
			if (v === 0) {
				this.checkStatus = 0;
			} else if (v > 0 && v < this.total) {
				this.checkStatus = 1;
			} else {
				this.checkStatus = 2;
			}
		},
		showClickNum (v) {
			if (v === this.canCheckNum && v !== 0) {
				this.allStatus = 2;
				//	this.timeSpend(v)
			} else if (v !== 0 && v < this.canCheckNum) {
				this.allStatus = 1;
				//	this.timeSpend(v)
			} else {
				this.allStatus = 0;
				// this.timeSpend(v)
			}
		},
		selectItems (v) {
			this.selectItem = this.listCopy.filter(item => {
				if (v === item.id) return item;
			});
		}
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		transitionAction: lib.transitionAction,
		setListSelect (data) {
			data.forEach(item => {
				if (!this.isTodayCreate(item.createdDate)) {
					item.isdisable = true;
					item.name += '';
				} else if (this.stationIdList.indexOf(item.id) > -1) {
					item.isSelect = true;
					item.isdisable = false;
					this.canCheckNum++;
				} else {
					item.isSelect = false;
					item.isdisable = false;
					this.canCheckNum++;
				}
			});
		},
		async show (selectItem, qtyType) {
			this.qtyType = qtyType;
			if (this.qtyType === 'single' && selectItem.length > 0) {
				this.selectItems = selectItem[0].id;
			} else if (this.qtyType !== 'single') {
				this.selectItem = selectItem || [];
			} else if (this.qtyType === 'single' && selectItem.length === 0) {
				this.selectItems = [];
			}
			// if (this.stationIdList.length > 0) {
			//	 this.getList()
			//	 // this.setListSelect(this.list)
			//	 this.$refs.window.show()
			//	 return
			// }
			this.Allnum = 0;
			this.showClickNum = 0;
			this.canCheckNum = 0;
			this.stationIdList = [];
			this.loading = true;
			this.filterConfirm();
			setTimeout(() => {
				this.getList('clear');
				this.setSelect();
				this.loading = false;
			}, 0);
		// this.loading = false
		},
		timeSpend (num) {
			if (num < 101 && num > 0) {
				this.timeuse = '15s';
			} else if (num > 100 && num < 301) {
				this.timeuse = '30s';
			} else if (num > 300 && num < 1001) {
				this.timeuse = '2min';
			} else if (num > 1000 && num < 2001) {
				this.timeuse = '3min';
			} else if (num > 2000 && num < 4001) {
				this.timeuse = '5min';
			} else if (num > 4000 && num < 8001) {
				this.timeuse = '9min';
			} else if (num > 8000) {
				this.timeuse = '16min';
			} else if (num == 0) {
				this.timeuse = '0s';
			}
		},
		afterclear: function () {
			if (this.requestData.name) this.searchList();
		},
		searchList () {
			this.filterQuick.name.active = this.searchKey;
			this.$set(this.pagination.request, 'page', 1);
			this.getList();
		},
		filterConfirm () {
			if (this.filterAdvTemp.powerArea.active[0] && this.filterAdvTemp.powerArea.active[1]) {
				if (Number(this.filterAdvTemp.powerArea.active[0]) > Number(this.filterAdvTemp.powerArea.active[1])) {
					this.capacityFalse = true;
				} else {
					this.capacityFalse = false;
				}
			} else {
				this.capacityFalse = false;
			}
			if (this.fromW) {
				return;
			}
			if (!this.capacityFalse) {
				this.filterAdv.tag.list = $.extend(true, [], this.filterAdvTemp.tag.list);
				this.filterAdv.user.list = $.extend(true, [], this.filterAdvTemp.user.list);
				this.filterAdv.business.list = $.extend(true, [], this.filterAdvTemp.business.list);
				this.getList(this.filterAdvTemp, 'filterAdv');
				if (this.$refs.filterAdv) {
					this.$refs.filterAdv.hide();
				}
			}
		},
		updatePersonList (list, fullList) {
			var arr = [];
			for (let	i in fullList) {
				let o = {id: i, name: fullList[i], checked: true};
				arr.push(o);
			}
			if (this.filterAdv.members.list.length == 0) this.filterAdvTemp.members.list = [];
			this.filterAdvTemp.members.list = arr;
			//		this.filterAdvTemp.relatedPersonIds.active = list.join(',')
			//		// this.filterAdvTemp.relatedPersonIds.displayVal="";
			//		// let array=Object.keys(fullList);
			//		let array = new Array()
			//		$.each(fullList, function (k, v) {
			//		array.push(v)
			//		})
			//		this.filterAdvTemp.relatedPersonIds.displayVal = array.join(', ') // displayVal：显示值（类型要和active和def的类型保持一致，避免清空或生成tag时出错）
			//		this.filterAdvTemp.relatedPersonIds.fullList = JSON.stringify(fullList)
		},
		filterAdvSelect: function (index, name) {
			let targetList = [];
			switch (name) {
			// case "customerSource":
			// targetList=this.customerSourceList;
			// this.$set(this.filterAdvTemp,key,targetList[index].value);
			// break;
			case 'sources':
				$.each(this.filterAdvTemp[name], function (k, v) { // 列表值全复位
					app.$set(app.filterAdvTemp[name], k, false);
				});
				this.$set(this.filterAdvTemp[name], this.customerSourceList[index].value, true);
				break;
			case 'area0ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[0] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';

				this.$set(this.filterAdvTemp.area1ID, 'active', this.filterAdvTemp.area1ID.data[0].id);
				this.filterAdvTemp.addressOut.active[1] = '';
				this.$set(this.filterAdvTemp.area2ID, 'active', this.filterAdvTemp.area2ID.data[0].id);
				this.filterAdvTemp.addressOut.active[2] = '';
				this.$set(this.filterAdvTemp.area3ID, 'active', this.filterAdvTemp.area3ID.data[0].id);
				this.filterAdvTemp.addressOut.active[3] = '';
				this.$set(this.filterAdvTemp.area4ID, 'active', this.filterAdvTemp.area4ID.data[0].id);
				this.filterAdvTemp.addressOut.active[4] = '';
				this.$set(this.filterAdvTemp.area5ID, 'active', this.filterAdvTemp.area5ID.data[0].id);
				this.filterAdvTemp.addressOut.active[5] = '';

				this.getFilterMapArea(2, this.filterAdvTemp[name].data[index].id);
				break;
			case 'area1ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[1] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';

				this.$set(this.filterAdvTemp.area2ID, 'active', this.filterAdvTemp.area2ID.data[0].id);
				this.filterAdvTemp.addressOut.active[2] = '';
				this.$set(this.filterAdvTemp.area3ID, 'active', this.filterAdvTemp.area3ID.data[0].id);
				this.filterAdvTemp.addressOut.active[3] = '';
				this.$set(this.filterAdvTemp.area4ID, 'active', this.filterAdvTemp.area4ID.data[0].id);
				this.filterAdvTemp.addressOut.active[4] = '';
				this.$set(this.filterAdvTemp.area5ID, 'active', this.filterAdvTemp.area5ID.data[0].id);
				this.filterAdvTemp.addressOut.active[5] = '';

				this.getFilterMapArea(3, this.filterAdvTemp[name].data[index].id);
				break;
			case 'area2ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[2] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';

				this.$set(this.filterAdvTemp.area3ID, 'active', this.filterAdvTemp.area3ID.data[0].id);
				this.filterAdvTemp.addressOut.active[3] = '';
				this.$set(this.filterAdvTemp.area4ID, 'active', this.filterAdvTemp.area4ID.data[0].id);
				this.filterAdvTemp.addressOut.active[4] = '';
				this.$set(this.filterAdvTemp.area5ID, 'active', this.filterAdvTemp.area5ID.data[0].id);
				this.filterAdvTemp.addressOut.active[5] = '';

				this.getFilterMapArea(4, this.filterAdvTemp[name].data[index].id);
				break;
			case 'area3ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[3] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';

				this.$set(this.filterAdvTemp.area4ID, 'active', this.filterAdvTemp.area4ID.data[0].id);
				this.filterAdvTemp.addressOut.active[4] = '';
				this.$set(this.filterAdvTemp.area5ID, 'active', this.filterAdvTemp.area5ID.data[0].id);
				this.filterAdvTemp.addressOut.active[5] = '';

				this.getFilterMapArea(5, this.filterAdvTemp[name].data[index].id);
				break;
			case 'area4ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[4] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';

				this.$set(this.filterAdvTemp.area5ID, 'active', this.filterAdvTemp.area5ID.data[0].id);
				this.filterAdvTemp.addressOut.active[5] = '';

				this.getFilterMapArea(6, this.filterAdvTemp[name].data[index].id);
				break;
			case 'area5ID':
				this.$set(this.filterAdvTemp[name], 'active', this.filterAdvTemp[name].data[index].id);
				this.filterAdvTemp.addressOut.active[5] = index > 0 ? this.filterAdvTemp[name].data[index].name : '';
				break;

		// case "":break;
			}
		},
		hide () {
			this.$refs.window.hide();
		},
		filterClose () {
		// this.filterAdvTemp.tagList = _.cloneDeep(this.filterAdv.tagList);
		},
		endFlow () {
			this.isSelectAll = false;
			this.stationIdList = [];
			this.stationNameList = [];
			this.searchKey = '';
			this.filterQuick.name.active = this.searchKey;
		},
		save () {
			if (this.selectItem.length == 0) {
				this.$notify(getLanguageStr('report28', '至少选择一个对象'));
				return;
			}
			// let stid = [...this.stationIdList]
			// let stname = [...this.stationNameList]

			// this.$emit('EmitStationIdList', stid, this.activeInspectType, stname)
			this.$emit('EmitStationIdList', [...this.selectItem]);
		},
		isTodayCreate (time) {
			let today = new Date();
			today.setSeconds(0);
			today.setMilliseconds(0);
			today.setHours(0);
			today.setMinutes(0);
			// console.log(time, today.getTime())
			if (time * 1000 < today.getTime()) {
				return true;
			} else {
				// alert('今天的电站无法被创建')
				return true;
			}
		},
		selectAllData (isC) {
			if (isC) {
				this.checkStatus = 2;
				// 全选的情况下添加所有的数据
				let noChooseItem = this.listCopy.filter(itemAll => {
					if (!this.isContain(itemAll)) {
						itemAll.isSelect = true;
						return itemAll;
					}
				});
				let selectItemCopy = [...noChooseItem, ...this.selectItem];
				this.selectItem = selectItemCopy;
				this.selectNum = this.getselectNum();
			} else {
				this.checkStatus = 0;
				// 取消全选的状态只是取消当前页面的全部取消状态
				let All = this.selectItem.filter(itemAll => {
					if (!this.isContainInList(itemAll) || itemAll.disabled) {
						return itemAll;
					} else {
						itemAll.isSelect = false;
					}
				});
				this.selectItem = All;
				this.selectNum = this.selectItem.length;
				this.setSelect();
			}
		},
		isContain (item) {
			let has = false;
			this.selectItem.map(its => {
				if (its.id === item.id) has = true;
			});
			return has;
		},
		isContainInList (item) {
			let has = false;
			this.listCopy.map(its => {
				if (its.id === item.id) has = true;
			});
			return has;
		},
		filterCheck (item) {
			let items = this.selectItem.filter(its => {
				if (its.id !== item.id) return its;
				else item.isSelect = false;
			});

			return items;
		},
		// 当前页面的选中的个数
		getselectNum () {
			let num = 0;
			let numArr = this.listCopy.filter(item => {
				if (item.isSelect) return item;
			});
			num = numArr.length;
			return num;
		},
		selectData (isC, index, item) {
			if (this.qtyType === 'single') {
		 if (index) {
					this.$emit('EmitStationIdListSingle', index);
		 }
				// console.log(isC)
			} else {
		 if (isC && !this.isContain(item)) {
					this.selectItem.push(item);
					item.isSelect = true;
					this.selectNum = this.getselectNum();
				} else {
					this.selectItem = this.filterCheck(item);
					this.selectNum = this.getselectNum();
				}
			}
		},
		selectInspectType () {

		},
		getListByKey () {

		},

		tagAction: function () { // $target,key
			if ($.isEmptyObject(this.tagMap)) {
				$('.filter .filterArea').stop().slideUp(200, function () {
				});
			} else {
				$('.filter .filterArea').stop().slideDown(200, 'easeInOutExpo', function () {
					$('.filter .filterArea').css('height', '');
				});
			}
			setTimeout(lib.fillHeight, 500);
		},
		openFilterAdv () {
			this.SonComponents.filter = true;
			this.capacityFalse = false;
			this.$nextTick(() => {
				this.$refs.filterAdv.show();
				this.getCountry();
				this.getFilterMapArea();
				this.filterAdvSync(false);
				this.$refs.TagManageCore.show();
				this.$refs.TagManageUser.show();
				this.$refs.TagManageBusiness.show();
			});
		},
		filterAdvSync (sync = false) { // 同步高级筛选数据
			if (sync) { // 确定
				$.extend(true, this.filterAdv, this.filterAdvTemp);
			} else {
				$.extend(true, this.filterAdvTemp, this.filterAdv);// 取消
				if (this.filterAdv.tag.list.length == 0) this.filterAdvTemp.tag.list = [];//	数组需要特殊处理
				if (this.filterAdv.members.list.length == 0) this.filterAdvTemp.members.list = [];
				if (this.filterAdv.user.list.length == 0) this.filterAdvTemp.user.list = [];
				if (this.filterAdv.business.list.length == 0) this.filterAdvTemp.business.list = [];
				// this.$set(this.filterAdvTemp.tag,"list",[]);
				/* 以下，对related-person组件TagBox更新视图 & 重置(不使用它的reset，因要保持当前personList) */
				this.$refs.SearchPerson.flag = false;
				this.$refs.SearchPerson.searchKey = '';
				if (this.filterAdv.relatedPersonIds.fullList == '') this.$refs.SearchPerson.personList = {}; // 空则直接打空对象
				else this.$refs.SearchPerson.personList = JSON.parse(lib.stringFormatForJson(this.filterAdv.relatedPersonIds.fullList));	// 非空则字符串转对象
				this.$refs.SearchPerson.tagAction();	// 对related-person组件TagBox样式操作
			}
		// this.$nextTick(function(){
		// });
		},
		getCountry () {
			searchAreaListByLevel(1).then(res => {
				this.filterAdvTemp.area0ID.data = [{name: getLanguageStr('cmd19', '全部'), id: null,	def: getLanguageStr('word675', '国家')}].concat(res);
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		getFilterMapArea: function (targetLevel = 2, fromId = this.filterAdv.area0ID.active) { // 获取每级列表
			let $this = this;
			if (fromId == null) fromId = -1;
			searchAreaList(fromId).then(
				function (data) {
					// trace(data,true);
					let key = '';
					switch (targetLevel) {
					case 1:
						key = 'area0ID';
						break;
					case 2:
						key = 'area1ID';
						if ($this.filterAdvTemp.area0ID.active == 44) { // 中国显示省市区
							$this.filterAdvTemp.area1ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('word676', '省')}];
						} else {
							$this.filterAdvTemp.area1ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('cmd19', '全部')}];
						}
						break;
					case 3:
						key = 'area2ID';
						if ($this.filterAdvTemp.area0ID.active == 44) { // 中国显示省市区
							$this.filterAdvTemp.area2ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('word677', '市')}];
						} else {
							$this.filterAdvTemp.area3ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('cmd19', '全部')}];
						}
						break;
					case 4:
						key = 'area3ID';
						if ($this.filterAdvTemp.area0ID.active == 44) { // 中国显示省市区
							$this.filterAdvTemp.area3ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('word889', '区')}];
						} else {
							$this.filterAdvTemp.area3ID.data = [{name:	getLanguageStr('cmd19', '全部'), id: null, def: getLanguageStr('cmd19', '全部')}];
						}
						break;
					case 5:
						key = 'area4ID';
						break;
					case 6:
						key = 'area5ID';
						break;
					}
					let newAddressList = data || [];
					newAddressList.unshift(app.filterAdvTemp[key].data[0]);
					app.$set(app.filterAdvTemp[key], 'data', newAddressList);
				}
			);
		},
		getList: function (data, targetKey, type) {
		// this.stationNameList = []
		// this.stationIdList = []
			this.isSelectAll = false;
			lib.loadingChange($('.tableScope [loading]'), 'true');
			this.loadingDate = true;
			if (data === 'clear') {
				this.filterAdv.tag.list = this.filterAdvTemp.tag.list = [];
				this.filterAdv.members.list = this.filterAdvTemp.members.list = [];
				this.filterAdv.user.list = this.filterAdvTemp.user.list = [];
				this.filterAdv.business.list = this.filterAdvTemp.business.list = [];
				$.each(this.filterAdv, function (key, val) {
					if (this.displayVal != undefined) this.displayVal = this.displayValDef; // 初始化显示值
					if (this.fullList != undefined) this.fullList = this.fullListDef; // 初始化给组件的TagBox循环对象传值
					if ($.isPlainObject(app.filterAdv[key].active) || this.active != this.def) {
						if ($.isPlainObject(app.filterAdv[key].active)) { // obj格式的继续遍历初始化值
							$.each(app.filterAdv[key].active, function (k) {
								app.$set(app.filterAdv[key].active, k, app.filterAdv[key].def[k]);
							});
						} else if ($.type(app.filterAdv[key].active) == 'array') { // 数组格式单独深拷贝，否则因为引用问题导致bug
							$.extend(true, app.filterAdv[key].active, app.filterAdv[key].def);
						} else app.$set(app.filterAdv[key], 'active', app.filterAdv[key].def);
					}
				});
				// 处理地址
				$.extend(true, this.filterAdv.addressOut.active, this.filterAdv.addressOut.def);
				$.extend(true, this.filterAdv.powerArea.active, this.filterAdv.powerArea.def);
				this.filterAdv.area0ID.active = this.filterAdv.area0ID.def;
				this.filterAdv.area1ID.active = this.filterAdv.area1ID.def;
				this.filterAdv.area2ID.active = this.filterAdv.area2ID.def;
				this.filterAdv.area3ID.active = this.filterAdv.area3ID.def;
				// this.$set(this.filter.area3ID,1,this.filter.area3ID[0]);
				// this.$set(this.filter.area1ID,1,this.filter.area1ID[0]);
				// this.$set(this.filter.area2ID,1,this.filter.area2ID[0]);
				// this.$set(this.filter.area3ID,1,this.filter.area3ID[0]);

				app.$set(app, 'tagMap', {});
				// this.$refs.SearchPerson.reset(); //关联人选择清空
			} else if ($.isPlainObject(data)) { // 批量数据
				// lib.windowCtrl("#filterAdv","false");
				$.extend(true, this[targetKey], data);
				//	app.$set(app.filterAdv.area3ID,1,app.filterAdv.area3ID[0]);
				//	app.$set(app.filterAdv.area1ID,1,app.filterAdv.area1ID[0]);
				//	app.$set(app.filterAdv.area2ID,1,app.filterAdv.area2ID[0]);
				//	app.$set(app.filterAdv.area3ID,1,app.filterAdv.area3ID[0]);
				if (this.filterAdv.relatedPersonIds.active == this.filterAdv.relatedPersonIds.def) {
					this.filterAdv.relatedPersonIds.displayVal = this.filterAdv.relatedPersonIds.displayValDef;
					this.filterAdv.relatedPersonIds.fullList = this.filterAdv.relatedPersonIds.fullListDef;
				} // 对displayVal及fullList的额外复原(点击tag的x)
				if (this.filterAdv.addressOut.active.join('') == this.filterAdv.addressOut.def.join('')) { // 额外处理地址复原
					this.filterAdv.area0ID.active = this.filterAdv.area0ID.def;
					this.filterAdv.area1ID.active = this.filterAdv.area1ID.def;
					this.filterAdv.area2ID.active = this.filterAdv.area2ID.def;
					this.filterAdv.area3ID.active = this.filterAdv.area3ID.def;
				}
				if (this.filterAdv.powerArea.active.join('') == this.filterAdv.powerArea.def.join('')) { // 额外处理地址复原
					// this.filterAdv.powerLower.active=this.filterAdv.powerLower.def;
					// this.filterAdv.powerHigher.active=this.filterAdv.powerHigher.def;
				}
				if (data['tag'] && type == 'remove') {
					this.filterAdv.tag.list = [];
					this.filterAdvTemp.tag.list = [];
				}
		 if (data['members'] && type == 'remove') {
					this.filterAdv.members.list = [];
					this.filterAdvTemp.members.list = [];
				}
				if (data['user'] && type == 'remove') {
					this.filterAdv.user.list = [];
					this.filterAdvTemp.user.list = [];
				}
				if (data['business'] && type == 'remove') {
					// console.log('yes')
					this.filterAdv.business.list = [];
					this.filterAdvTemp.business.list = [];
				}
			}
			//			this.filterAdv.tagList = this.$refs.TagManageCore.tagList;//设置tag

			$.each(this.filterAdv, function (key, val) { // 处理高级筛选tag
				val = val.active;
				// console.log(val)
				if (this.name) { // 仅有name的进行处理(filterAdv声明中定义)
					// app.$nextTick(function(){
					if (typeof (this.displayVal) !== 'undefined') {
						val = this.displayVal;
					}
					if ($.isPlainObject(val)) { // 多选格式
						$.each(this.active, function (k, v) {
							if (v) { // &&!app.tagMap[k+v]
								app.$set(app.tagMap, k + v, {val: v, key: key});
							} else if (v == app.filterAdv[key].def[k] && app.tagMap[k + v]) { // 无效值且残留在tagMap，需要删除
								app.$delete(app.tagMap, k + v);
							}
						});
					} else if ($.inArray($.type(val), ['string', 'number', 'boolean', 'null']) >= 0) {
						if (val) { // &&!app.tagMap[key]
							app.$set(app.tagMap, key, {val: val,	key: key});
							// app.tagMap[key]={val:val,key:key};
						} else if (val == app.filterAdv[key].def && app.tagMap[key]) { // 无效值且残留在tagMap，需要删除
							app.$delete(app.tagMap, key);
						}
					} else if ($.type(val) == 'array') {
						if (val.join('') != app.filterAdv[key].def.join('')) { // &&!app.tagMap[key]
							let joinStr = key === 'powerArea' ? '~' : ' ';
							app.$set(app.tagMap, key, {val: val.join(joinStr), key: key});
						} else if (val.join('') == app.filterAdv[key].def.join('') && app.tagMap[key]) { // 无效值且残留在tagMap，需要删除
							app.$delete(app.tagMap, key);
						}
					}
					// });
				}
			});

			if (data) this.$set(this.pagination.request, 'page', 1);

			this.requestData = {
				powerTypeList: this.powerTypeList
			};
			function outData (targetData, type) { // 值处理，例如多选的格式仅输出有效的值
				if ($.isPlainObject(targetData)) { // 处理多选参数的字段
					let list = [];
					$.each(targetData, function (k) {
						if (this && Number(k) >= 0) list.push(k);// key值小于0的不计，例如“全部”
					});
					targetData = list.length ? list : null;
				}
				if (type & type == 'areaValue') { // 区间值的处理
					if (targetData.length == 2) {
						targetData = targetData.join('~');
					} else if (targetData[0] == '') {
						targetData = targetData[1] + '';
					}
				}
				return targetData;
			}
			$.each(this.filterQuick, function (key, val) { // 合并快速筛选中的所有条件
				let result = outData(this.active, this.type);
				if (result && result != app.filterQuick[key].def) {
					if (this.parent) {
						if (app.requestData[this.parent] == undefined) app.requestData[this.parent] = {};
						if (result != null && result != app.filterQuick[key].def) app.requestData[this.parent][key] = result;
					} else if (this.keyBefore && result && result != app.filterQuick[key].def) {
						app.requestData[this.keyBefore + key] = result;
					} else { // 没有上一级字段
						if (result != app.filterQuick[key].def) app.requestData[key] = result;
					}
				}
			});
			$.each(this.filterAdv, function (key, val) { // 合并高级筛选中的所有条件
				if (this.request) {
					let result = outData(this.active, this.type);
					if (result && result != app.filterAdv[key].def) {
						if (this.parent && result && result != app.filterAdv[key].def) {
							if (app.requestData[this.parent] == undefined) app.requestData[this.parent] = {};
							app.requestData[this.parent][key] = result;// if(result!=null&&result!=app.filterAdv[key].def)
						} else if (this.keyBefore && result && result != app.filterAdv[key].def) {
							app.requestData[this.keyBefore + key] = result;
						} else { // 没有上一级字段
							if (result != app.filterAdv[key].def) app.requestData[key] = result;
						}
					}
				}
			});

			// 装机容量
			if (this.filterAdv.powerArea.active[0]) this.requestData.minInstalledCapacity = this.filterAdv.powerArea.active[0];
			if (this.filterAdv.powerArea.active[1]) this.requestData.maxInstalledCapacity = this.filterAdv.powerArea.active[1];
			// 区域
			this.requestData.region = {
				'nationId': this.filterAdv.area0ID.active,
				'level1': this.filterAdv.area1ID.active,
				'level2': this.filterAdv.area2ID.active,
				'level3': this.filterAdv.area3ID.active,
				'level4': this.filterAdv.area4ID.active,
				'level5': this.filterAdv.area5ID.active
			};
			// 投产状态
			if (this.filterAdv.runState.active == '1' || this.filterAdv.runState.active == 'running') {
				this.requestData.operating = true;
			} else if (this.filterAdv.runState.active == '0' || this.filterAdv.runState.active == 'unRunning') {
				this.requestData.operating = false;
			}

			// 关联人
			//		if (this.filterAdv.relatedPersonIds.active != '') {
			//		this.requestData.relatedUserIds = (this.filterAdv.relatedPersonIds.active || '').split(',')
			//		}
			// 标签
			if (this.filterAdv.tag.list.length > 0) {
				this.requestData.tagIds = this.filterAdv.tag.list.map(item => item.id);
				let tagIdNames = this.filterAdv.tag.list.map(item => item.name);
				this.tagMap.tagInfo = {key: 'tag',	val: tagIdNames.join(',')};
			} else {
				delete (this.tagMap.tagInfo);
			}
			this.requestData.externalRelationship = {};
			// 用户
			if (this.filterAdv.user.list.length > 0) {
				this.requestData.externalRelationship.externalUserEntityRelIdList = this.filterAdv.user.list.map(item => item.entityRelId);
				let userIdNames = this.filterAdv.user.list.map(item => item.name);
				this.tagMap.userInfo = {key: 'user', val: userIdNames.join(',')};
			} else {
				delete (this.tagMap.userInfo);
			}

			// 成员
			if (this.filterAdv.members.list.length > 0) {
				this.requestData.relatedUserIds = this.filterAdv.members.list.map(item => item.id);
				let userIdNames = this.filterAdv.members.list.map(item => item.name);
				this.tagMap.membersInfo = {key: 'members', val: userIdNames.join(',')};
			} else {
				delete (this.tagMap.membersInfo);
			}
			// 商家  business
			if (this.filterAdv.business.list.length > 0) {
				// console.log(this.filterAdv.business)
				this.requestData.externalRelationship.externalCompanyEntityRelIdList = this.filterAdv.business.list.map(item => item.entityRelId);
				let businessIdNames = this.filterAdv.business.list.map(item => item.name);
				this.tagMap.businessInfo = {key: 'business', val: businessIdNames.join(',')};
			} else {
				delete (this.tagMap.businessInfo);
			}
			this.tagAction();

			// let pagination={pagination:$.extend({},this.pagination.request,{order:this.order})};//合并分页数据//合并排序数据
			// pagination.pagination={...pagination.pagination,...};
			// this.requestData={...this.requestData,...this.pagination.request,...{"order.direction":this.orderDirection,"order.property":this.orderProperty}};
			// this.requestData={...this.requestData,};
			let pages = {...this.pagination.request,	...{'order.direction':	'ASC', 'order.property': 'name'}};
			// this._getClueList(this.requestData);

			apiGetList(pages, this.requestData).then(success => {
				// trace(success,true);
				// console.log(success)
				this.list = success.data;
				this.total = success.data.length;
				this.listCopy = success.data;
				this.setSelect();
				this.selectNum = this.getselectNum();
				this.checkAllStatus();
				this.total = this.listCopy.length;
				this.showClickNum = 0;
				this.canCheckNum = 0;
				// success.data.map(item => {
				//	 if (!this.isTodayCreate(item.createdDate)) {
				//		 item.isdisable = true
				//		 item.name += '（当前电站为当日创建电站，无法参与体检，请与明日早上6:00后再次体检该电站。）'
				//	 } else if (this.stationIdList.indexOf(item.id) > -1) {
				//		 item.isSelect = true
				//		 item.isdisable = false
				//		 this.canCheckNum++
				//		 this.showClickNum++
				//	 } else {
				//		 item.isSelect = false
				//		 item.isdisable = false
				//		 this.canCheckNum++
				//	 }
				// })
				this.Allnum = this.stationIdList.length;
				app.list = success.data;
				app.pagination.total = this.statusCount.TOTAL = success.total;
				// app.$set(app.pagination,"total",success.total);
				let {total} = success;
				app.pagination = {...app.pagination, ...{total}};
				// app.pagination=$.extend(true,app.pagination,{total:success.total});
				this.selectQty = this.selectAllStatus = 0;//	重置全选状态
				this.$nextTick(() => {
					// console.log("fillHeight")
					lib.fillHeight();
					lib.setScroll($('#selectView [fillHeight][scroll]'));
					lib.loadingChange($('.tableScope [loading]'), 'false');
				});
				this.loadingDate = false;
			}, error => {
				this.loadingDate = false;
				// error=$.parseJSON(error);
				// trace(error);
				!_.isEmpty(error) && this.$notify(error);
				// alert(error.error);
				lib.loadingChange($('.tableScope [loading]'), 'false');
			}).then(() => {
				this.listCopy = this.list;
				this.setSelect();
				this.selectNum = this.getselectNum();
				this.checkAllStatus();
				this.total = this.listCopy.length;
				if (this.$parent.$parent.hideloadding) {
					this.$parent.$parent.hideloadding();
				}
			});
		// this.getStatusCount();
		},
		// 判断已经选中状态下是否存在这个值
		isContainInSelect (item) {
			let has = false;
			// this.selectItem.length > 0 && console.log(item.id, this.selectItem[0].id)

			this.selectItem.map(items => {
				if (items.id === item.id) has = true;
			});
			return has;
		},
		checkAllStatus () {
			if (this.selectNum === 0) {
				this.checkStatus = 0;
			} else if (this.selectNum > 0 && this.selectNum < this.total) {
				this.checkStatus = 1;
			} else {
				this.checkStatus = 2;
			}
		},
		// 设置目前的选中状态
		setSelect () {
			this.listCopy.map(item => {
				if (this.isContainInSelect(item)) item.isSelect = true;
				else item.isSelect = false;
			});
		}
	},

	mounted () {
		app = this;
		lib.fillHeight();
		lib.setScroll($('#selectView [fillHeight][scroll]'));
	}
};
</script>
<style lang="scss" scoped>
.bgDesktop {
	background-color: $bgDesktop;
	.panel{
	padding-top:2em;
			.wrap-stat{
			padding-left: 2em;
			padding-right:2em;
				.m2b1{
		margin-top:2em;
		margin-bottom: 1em;
		width:20em;
	}
	.splitLine{
				margin-top:1em
			}
		}
	}
}
.filter .filterArea {
	box-shadow: none;
}
.fs13x {
	font-size: 1.3rem;
}
.h30-max{
	.panel{
		padding-top:0.5em;
			.m2b1{
				width:80%;
				padding-left:2em;
				.bgContent{
					padding-left: 2em;
				}
			}
			.splitLine{
				margin-top:0.5em
			}
	}
}
.custcss{
	position: absolute;
	z-index: 10003;
	background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SelectStationCommon.vue